// extracted by mini-css-extract-plugin
export default {"secondaryButton":"SecondaryButton_secondaryButton__7oR+L"};